/**
 * For pt-multiopticas, the only product type for which the
 * promote installments component should be shown is sunglasses
 */
export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 60,
  numberOfInstallments: 3,
}
